import moment from "moment-timezone";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { roleOptionsForSelect } from "../../config/config";

export const ModalVisualizzaEvento = ({ selectedEvent, show, setShow, dateStart }) => {
  const ep = selectedEvent?.extendedProps || {};

  const title = selectedEvent?.title || ep.title || "";
  const description = ep.description || "";
  const location = ep.location || "";
  const place = ep.place || "";

  const start = selectedEvent?.start
    ? moment(selectedEvent.start)
    : ep.startDate
    ? moment(ep.startDate)
    : null;
  const end = selectedEvent?.end
    ? moment(selectedEvent.end)
    : ep.endDate
    ? moment(ep.endDate)
    : null;
  const isAllDay = !!(selectedEvent?.allDay || ep.allDay);
  const color = ep.color || selectedEvent?.backgroundColor;
  const department = typeof ep.department !== "undefined" ? ep.department : null;
  const medico = ep.medico || null;

  const departmentLabel = (() => {
    if (department === -1) return "Personale";
    const found = roleOptionsForSelect.find(([value]) => parseInt(value) === parseInt(department));
    return found ? found[1] : department === null ? "" : String(department);
  })();

  const formatRange = () => {
    if (!start || !end) return "";
    const sameDay = start.isSame(end, "day");
    if (isAllDay) {
      return sameDay
        ? `${start.format("DD MMMM YYYY")} (tutto il giorno)`
        : `${start.format("DD MMMM YYYY")} → ${end.format("DD MMMM YYYY")} (tutto il giorno)`;
    }
    return sameDay
      ? `${start.format("DD MMMM YYYY, HH:mm")} → ${end.format("HH:mm")}`
      : `${start.format("DD MMMM YYYY, HH:mm")} → ${end.format("DD MMMM YYYY, HH:mm")}`;
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header className="border-0 d-flex justify-content-center">
        <Modal.Title className="text-center">{title}</Modal.Title>
        
      </Modal.Header>
      <Modal.Body>
        {description ? <div style={{ whiteSpace: "pre-wrap" }}>{description}</div> : null}
        {start && end ? <div className="m-2"><div style={{ width: 24, display: "inline-block", textAlign: "center" }}><i className="fas fa-calendar me-2"></i></div> <strong></strong> {formatRange()}</div> : null}
        {/* {typeof departmentLabel === "string" && departmentLabel !== "" ? (
          <p><strong>Visibilità:</strong> {departmentLabel}</p>
        ) : null} */}
        
        { /* Metto le icone in un container di 16px di lunghezza*/ }
        {location ? <div className="m-2"><div style={{ width: 24, display: "inline-block", textAlign: "center" }}><i className="fas fa-map-marker-alt me-2"></i></div> <strong></strong><a href={`https://maps.google.com/?q=${encodeURIComponent(location)}`} target="_blank" rel="noopener noreferrer">{location}</a></div> : null}
        {place ? <div className="m-2"><div style={{ width: 24, display: "inline-block", textAlign: "center" }}><i className="fas fa-hotel me-2"></i></div> <strong></strong>{place}</div> : null}


        {medico && medico.firstname && medico.lastname ? (
          <div className="m-2 mt-8">
            <div style={{ marginBottom: 4 }}><div style={{ width: 24, display: "inline-block", textAlign: "center" }}><i className="fas fa-user-md me-2"></i></div> <strong>Medico:</strong> {`${medico.firstname || ""} ${medico.lastname || ""}`.trim()}</div>
            {medico.specializzazione ? <div style={{ marginBottom: 4 }}><strong>Specializzazione:</strong> {medico.specializzazione}</div> : null}
            {medico.address ? <div style={{ marginBottom: 4 }}><strong>Indirizzo:</strong> {medico.address}</div> : null}
            {medico.email ? <div style={{ marginBottom: 4 }}><strong>Email:</strong> {medico.email}</div> : null}
            {medico.phone ? <div style={{ marginBottom: 0 }}><strong>Telefono:</strong> {medico.phone}</div> : null}
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button onClick={() => setShow(false)}>Chiudi</Button>
      </Modal.Footer>
    </Modal>
  );
};
